/**
 * Shared review-photo modal (snippets/review-photo-modal.liquid, a native
 * <dialog> included once in layout/theme.liquid). Any review photo rendered
 * by snippets/review-card.liquid opts in via `data-review-photo-trigger` -
 * see that snippet's doc comment for the full data-review-photo-* contract.
 * All triggers sharing the same `data-review-photo-group` become one set
 * for prev/next paging (every field on the details pane is duplicated on
 * every trigger in a group, since they all belong to the same review).
 */
function initReviewPhotoModal() {
  const dialog = document.querySelector('[data-review-photo-modal]');
  if (!dialog) return;

  const image = dialog.querySelector('[data-review-photo-modal-image]');
  const count = dialog.querySelector('[data-review-photo-modal-count]');
  const prevButton = dialog.querySelector('[data-review-photo-modal-prev]');
  const nextButton = dialog.querySelector('[data-review-photo-modal-next]');
  const stars = dialog.querySelector('[data-review-photo-modal-stars]');
  const verified = dialog.querySelector('[data-review-photo-modal-verified]');
  const title = dialog.querySelector('[data-review-photo-modal-title]');
  const body = dialog.querySelector('[data-review-photo-modal-body]');
  const tags = dialog.querySelector('[data-review-photo-modal-tags]');
  const author = dialog.querySelector('[data-review-photo-modal-author]');
  const productLink = dialog.querySelector('[data-review-photo-modal-product-link]');
  const starFilledTemplate = dialog.querySelector('[data-review-photo-modal-star-filled]');
  const starEmptyTemplate = dialog.querySelector('[data-review-photo-modal-star-empty]');
  const tagTemplate = dialog.querySelector('[data-review-photo-modal-tag-template]');

  let group = [];
  let index = 0;

  function renderStars(rating) {
    if (!stars || !starFilledTemplate || !starEmptyTemplate) return;
    stars.innerHTML = '';
    for (let i = 1; i <= 5; i += 1) {
      const template = i <= rating ? starFilledTemplate : starEmptyTemplate;
      stars.appendChild(template.content.cloneNode(true));
    }
  }

  function addTag(text) {
    if (!tags || !tagTemplate || !text) return;
    const tag = tagTemplate.content.cloneNode(true);
    tag.querySelector('.review-card__tag').textContent = text;
    tags.appendChild(tag);
  }

  function populateDetails(trigger) {
    renderStars(Number(trigger.dataset.reviewPhotoRating) || 0);

    if (verified) verified.hidden = trigger.dataset.reviewPhotoVerified !== 'true';
    if (title) title.textContent = trigger.dataset.reviewPhotoTitle || '';
    if (body) body.textContent = trigger.dataset.reviewPhotoBody || '';
    if (author) author.textContent = trigger.dataset.reviewPhotoAuthor || '';

    if (tags) {
      tags.innerHTML = '';
      addTag(trigger.dataset.reviewPhotoFit);
    }

    if (productLink) {
      const productUrl = trigger.dataset.reviewPhotoProductUrl;
      if (productUrl) {
        productLink.href = productUrl;
        productLink.hidden = false;
      } else {
        productLink.hidden = true;
      }
    }
  }

  function show(newIndex) {
    if (!group.length) return;
    index = (newIndex + group.length) % group.length;
    const trigger = group[index];

    image.src = trigger.dataset.reviewPhotoSrc;
    image.alt = trigger.dataset.reviewPhotoAlt || '';
    if (count) count.textContent = group.length > 1 ? `${index + 1} / ${group.length}` : '';
    if (prevButton) prevButton.hidden = group.length <= 1;
    if (nextButton) nextButton.hidden = group.length <= 1;

    populateDetails(trigger);
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-review-photo-trigger]');
    if (!trigger) return;

    const groupName = trigger.dataset.reviewPhotoGroup || 'default';
    group = Array.from(document.querySelectorAll(`[data-review-photo-trigger][data-review-photo-group="${CSS.escape(groupName)}"]`));
    show(group.indexOf(trigger));
    dialog.showModal();
  });

  dialog.querySelector('[data-review-photo-modal-close]')?.addEventListener('click', () => dialog.close());
  prevButton?.addEventListener('click', () => show(index - 1));
  nextButton?.addEventListener('click', () => show(index + 1));

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });

  dialog.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') show(index - 1);
    if (event.key === 'ArrowRight') show(index + 1);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initReviewPhotoModal);
} else {
  initReviewPhotoModal();
}
